import { groupToSI, roundNumber, useLemonadeContext } from "@/LemonadeProvider";
import "../styles/InventoryList.css";

export function InventoryList() {
    const { inventory } = useLemonadeContext();

    const entries = Object.entries(inventory);

    if (entries.length === 0) {
        return (
            <section className="inventory-section">
                <h1 className="main-title">Készlet</h1>
                <div className="inventory-empty">Nincs készleten alapanyag.</div>
            </section>
        );
    }

    return (
        <section className="inventory-section">
            <h1 className="main-title">Készlet</h1>
            <div className="inventory-list">
                {entries.map(([name, entry]) => (
                    <div className="inventory-card" key={name}>
                        <h2 className="inventory-title">{name}</h2>
                        <ul className="inventory-amounts">
                            {entry.volume > 0 && (
                                <li>
                                    {roundNumber(entry.volume, 2)} {groupToSI["volume"]}
                                </li>
                            )}
                            {entry.mass > 0 && (
                                <li>
                                    {roundNumber(entry.mass, 2)} {groupToSI["mass"]}
                                </li>
                            )}
                            {entry.unit > 0 && (
                                <li>
                                    {roundNumber(entry.unit, 1)} {groupToSI["unit"]}
                                </li>
                            )}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}
